import { render, staticRenderFns } from "./win-bidding-list.vue?vue&type=template&id=bb9265fe&scoped=true&"
import script from "./win-bidding-list.vue?vue&type=script&lang=js&"
export * from "./win-bidding-list.vue?vue&type=script&lang=js&"
import style0 from "./win-bidding-list.vue?vue&type=style&index=0&id=bb9265fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9265fe",
  null
  
)

export default component.exports